import styles from './Footer.module.css';

export default function Footer() {
  const moveTop = () => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  };

  return (
    <footer className={styles.footer}>
      <button className={styles.topButton} type="button" onClick={moveTop}>
        Back to top
      </button>
      <span>(c) Copyright Georg Krause, 2023</span>
      <span>Impressum at About</span>
    </footer>
  );
}
